import { PchpCategoryCodeArray } from '../common-structures/app.constants';
import { CaseDetailV2 } from '../common-structures/case-detail';

const CaseDetailUtils = {
	displayAllegations,
	displayPCHPAssessments,
	displayAssignedTo,
};

function displayAllegations(item: CaseDetailV2, paramName: string) {
	const allegations = item?.chargeAllegations || [];
	if (!allegations || allegations.length === 0) {
		return 'N/A';
	}
	let rs = allegations.map((i) => i[paramName]);
	rs = [...new Set(rs)];
	return rs.join(',\n');
}

function displayPCHPAssessments(item: CaseDetailV2): string {
	if (item && item.pchpAssessments) {
		for (const i of item.pchpAssessments) {
			if (PchpCategoryCodeArray.find((pchpCategory) => pchpCategory === i.scvCategoryValueDescription)) {
				return i.scvCategoryValueDescription;
			}
		}
	} else {
		return '';
	}
}

function displayAssignedTo(item: CaseDetailV2): string {
	if (item && item.chargeAssignments && item.chargeAssignments.length > 0) {
		return item.chargeAssignments.map((i) => i.caFirstName + ' ' + i.caLastName).join(',');
	} else {
		return 'Not Assigned';
	}
}

export { CaseDetailUtils };
